export const REPORT_SUCCESSFUL = 'REPORT_SUCCESSFUL'

export const REPORT_ERROR_DENIED = 'REPORT_ERROR_DENIED'
export const REPORT_ERROR_NOCONNECTION = 'REPORT_ERROR_NOCONNECTION'
export const REPORT_ERRORS = [REPORT_ERROR_DENIED, REPORT_ERROR_NOCONNECTION]

// The following values are also used as locales.
// Don't rename them without adapting the locales.
export const TIME_FRAME_OPTION_EXACT_DATE = 'exactDate'
